/**
 * Created by neo on 04.01.17.
 */

import Config from '../Config/index';
import BackendFactory from "../Services/BackendFactory";

class PaymentService {
    stripeApiKey = null;

    constructor() {
    }

    async getPaymentIntent(amount, currency) {
        var backend = await BackendFactory();
        var intent = await backend.post('payment-intent', {
            amount,
            currency
        });

        return intent;
    }

    async getPaymentIntentForBooking(booking) {
        return this.getPaymentIntent(
            booking.getPriceToPay(),
            booking.currency
        );
    }
}

const instance = new PaymentService();
export default instance;



// WEBPACK FOOTER //
// ./src/App/Services/PaymentService.js